"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const index_1 = require("../index");
const utils_1 = require("./utils");
const TimePickerSelector = ({ device, selectorAnimationDirection, value, selectedValueIndex, onSelect, }) => {
    const selectedValue = selectedValueIndex === undefined ? value : value[selectedValueIndex];
    return (React.createElement("div", { style: {
            display: 'flex',
            flexDirection: 'column',
            position: 'absolute',
            top: 56,
            left: 0,
            zIndex: 4,
            width: device === 'Mobile' ? '100%' : 384,
            height: device === 'Mobile' ? '100%' : 378,
            background: index_1.white,
            animation: `${selectorAnimationDirection} 150ms ease-in-out`,
            alignItems: 'center',
        } },
        React.createElement("div", { style: {
                padding: device === 'Mobile' ? 24 : 16,
                width: '100%',
            } },
            React.createElement(index_1.TimePicker, { handleSecondsChange: (seconds) => {
                    if (selectedValueIndex === undefined) {
                        onSelect(utils_1.updateTimeOfDateTime(value, seconds));
                    }
                    else {
                        let tempDates = [...value];
                        tempDates[selectedValueIndex] = utils_1.updateTimeOfDateTime(tempDates[selectedValueIndex], seconds);
                        onSelect(tempDates);
                    }
                }, seconds: utils_1.getSecondsFromDate(selectedValue), containerStyle: {
                    width: device !== 'Mobile' ? 352 : 'none',
                } }))));
};
exports.default = TimePickerSelector;
